type Storage = typeof localStorage | typeof sessionStorage ;

export default class SuperStorage {
  storage: Storage;

  constructor(storage: Storage) {
    this.storage = storage;
  }

  get(key: string, defaultValue = null) {
    const value = this.storage.getItem(key);

    if (!value) {
      return defaultValue;
    }

    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  set(key: string, value: any) {
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }

    return this.storage.setItem(key, value);
  }

  remove(key: string) {
    return this.storage.removeItem(key);
  }

  clear(prefix = null) {
    if (prefix) {
      const keys = Object.keys(this.storage);

      keys.forEach((key) => {
        if (key.indexOf(prefix) === 0) {
          this.storage.removeItem(key);
        }
      });
    } else {
      return this.storage.clear();
    }
  }
}
